import { gateValidate } from '../../application/dtos/gate_validate'

export class gateEntity {
    constructor({id, name, is_entry, is_rfid, warehouse}){
        this.id = id;
        this.name = name;
        this.is_entry = is_entry;
        this.is_rfid = is_rfid;
        this.warehouse = warehouse;
    }

    isValid() {
        return gateValidate(this);
    }
}